import { ApiOperationItems } from "~enums/apiOperationItems";
import { useApiOperations } from "~hooks/useApiOperations.ts";
import type { AddStaffRole, UpdateStaffRole } from "~pages/Staff/types/staffRole.ts";
import { useAddStaffRole } from "./useAddStaffRole.ts";
import { useDeleteStaffRole } from "./useDeleteStaffRole.ts";
import { useUpdateStaffRole } from "./useUpdateStaffRole.ts";

export const useStaffService = () => {
  const { mutateAsync: addStaffRoleFn, isPending: isAddPending } = useAddStaffRole();
  const { mutateAsync: updateStaffRoleFn, isPending: isUpdatePending } = useUpdateStaffRole();
  const { mutateAsync: deleteStaffRoleFn, isPending: isDeletePending } = useDeleteStaffRole();

  const { create, update, remove } = useApiOperations(ApiOperationItems.STAFF);

  const addStaffRole = (payload: AddStaffRole) =>
    create(() => addStaffRoleFn(payload), {
      successMessageId: "staff.add.success",
      isSucceeded: () => true,
    });

  const updateStaffRole = (payload: UpdateStaffRole) =>
    update(() => updateStaffRoleFn(payload), {
      successMessageId: "staff.update.success",
    });

  const deleteStaffRole = async (roleId: string) =>
    Boolean(
      await remove(() => deleteStaffRoleFn(roleId), {
        successMessageId: "staff.delete.success",
      }),
    );

  return {
    addStaffRole,
    isAddPending,
    updateStaffRole,
    isUpdatePending,
    deleteStaffRole,
    isDeletePending,
  };
};
